import { createContext } from "react";

import type { DropInCallTimerContextValue } from "./DropInCallTimerContextValue";

export const DropInCallTimerContext = createContext<DropInCallTimerContextValue | null>(null);

DropInCallTimerContext.displayName = "DropInCallTimerContext";
